module.exports = __webpack_public_path__ + "static/media/ecuador.5886e2f4.svg";